import { render, staticRenderFns } from "./FreezingPointDepressionUpdated.vue?vue&type=template&id=c77821e8&"
import script from "./FreezingPointDepressionUpdated.vue?vue&type=script&lang=ts&"
export * from "./FreezingPointDepressionUpdated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports